__turbopack_context__.v({
  "bottomNav": "EBBBottomNav-module__wjjhNa__bottomNav",
  "icon": "EBBBottomNav-module__wjjhNa__icon",
  "label": "EBBBottomNav-module__wjjhNa__label",
  "navItem": "EBBBottomNav-module__wjjhNa__navItem",
});
